// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Organizations_container__OG5Fv {
  background-color: #f5fafa;
  width: 100%;
  height: calc(100vh - 97px);
  overflow-y: auto;
  border-radius: 0 0 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding-bottom: 1rem;
}

.Organizations_header__VUIj7 {
  width: 95%;
  background-color: white;
  border-radius: 8px;
}

.Organizations_headerContent__LOa7S {
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Organizations_orgBtn__DSy8s,
.Organizations_companyBtn__jvfm4 {
  background-color: #3082f6;
  border: none;
  padding: 0 16px;
  border-radius: 12px;
  height: 44px;
  color: white;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.Organizations_table__d6Ql2 {
  width: 95%;
  background-color: white;
  padding-bottom: 1rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Organizations_tableHeader__79sfx {
  padding: 12px 20px;
  height: 20px;
  background-color: #3082f6;
  width: 90%;
  border-radius: 0 0 8px 8px;
  display: flex;
  justify-content: space-between;
  color: white;
}

.Organizations_tableHeader__79sfx > div {
  width: 120px;
  display: inline-block;
  white-space: normal;
  word-wrap: break-word;
}

.Organizations_tableHeader__79sfx > div:nth-child(4),
.Organizations_tableHeader__79sfx > div:nth-child(5) {
  text-align: center;
}

.Organizations_notificationsDiv__vH2cd {
  width: 400px;
  border-radius: 8px;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Organizations_errorMsg__WJmRy {
  max-width: 500px;
  background-color: red;
  font-weight: 500;
  padding: 1rem;
  border-radius: 8px;
}

.Organizations_buttons__-HOfI,
.Organizations_toggleButtons__QMKmp {
  display: flex;
  gap: 20px;
}

.Organizations_toggleOrgBtn__w--qT,
.Organizations_toggleCompaniesBtn__fnV1w {
  padding: 6px 12px;
  border-radius: 8px;
  height: 44px;
  background-color: transparent;
  border: 1px solid #79818c1f;
  color: #1b1f3ba6;
  line-height: 24px;
  cursor: pointer;
}

.Organizations_active__VXNHq {
  background-color: #3082f6;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  height: 44px;
  line-height: 24px;
}

h1 {
  width: 78%;
  height: 100px;
  background-color: red;
}
`, "",{"version":3,"sources":["webpack://./src/components/organizations/Organizations.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,qBAAqB;AACvB","sourcesContent":[".container {\r\n  background-color: #f5fafa;\r\n  width: 100%;\r\n  height: calc(100vh - 97px);\r\n  overflow-y: auto;\r\n  border-radius: 0 0 0 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.header {\r\n  width: 95%;\r\n  background-color: white;\r\n  border-radius: 8px;\r\n}\r\n\r\n.headerContent {\r\n  padding: 8px 16px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.orgBtn,\r\n.companyBtn {\r\n  background-color: #3082f6;\r\n  border: none;\r\n  padding: 0 16px;\r\n  border-radius: 12px;\r\n  height: 44px;\r\n  color: white;\r\n  font-size: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.table {\r\n  width: 95%;\r\n  background-color: white;\r\n  padding-bottom: 1rem;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.tableHeader {\r\n  padding: 12px 20px;\r\n  height: 20px;\r\n  background-color: #3082f6;\r\n  width: 90%;\r\n  border-radius: 0 0 8px 8px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  color: white;\r\n}\r\n\r\n.tableHeader > div {\r\n  width: 120px;\r\n  display: inline-block;\r\n  white-space: normal;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.tableHeader > div:nth-child(4),\r\n.tableHeader > div:nth-child(5) {\r\n  text-align: center;\r\n}\r\n\r\n.notificationsDiv {\r\n  width: 400px;\r\n  border-radius: 8px;\r\n  margin-top: 1rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.errorMsg {\r\n  max-width: 500px;\r\n  background-color: red;\r\n  font-weight: 500;\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n}\r\n\r\n.buttons,\r\n.toggleButtons {\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n\r\n.toggleOrgBtn,\r\n.toggleCompaniesBtn {\r\n  padding: 6px 12px;\r\n  border-radius: 8px;\r\n  height: 44px;\r\n  background-color: transparent;\r\n  border: 1px solid #79818c1f;\r\n  color: #1b1f3ba6;\r\n  line-height: 24px;\r\n  cursor: pointer;\r\n}\r\n\r\n.active {\r\n  background-color: #3082f6;\r\n  color: white;\r\n  border: none;\r\n  padding: 6px 12px;\r\n  border-radius: 8px;\r\n  height: 44px;\r\n  line-height: 24px;\r\n}\r\n\r\nh1 {\r\n  width: 78%;\r\n  height: 100px;\r\n  background-color: red;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Organizations_container__OG5Fv`,
	"header": `Organizations_header__VUIj7`,
	"headerContent": `Organizations_headerContent__LOa7S`,
	"orgBtn": `Organizations_orgBtn__DSy8s`,
	"companyBtn": `Organizations_companyBtn__jvfm4`,
	"table": `Organizations_table__d6Ql2`,
	"tableHeader": `Organizations_tableHeader__79sfx`,
	"notificationsDiv": `Organizations_notificationsDiv__vH2cd`,
	"errorMsg": `Organizations_errorMsg__WJmRy`,
	"buttons": `Organizations_buttons__-HOfI`,
	"toggleButtons": `Organizations_toggleButtons__QMKmp`,
	"toggleOrgBtn": `Organizations_toggleOrgBtn__w--qT`,
	"toggleCompaniesBtn": `Organizations_toggleCompaniesBtn__fnV1w`,
	"active": `Organizations_active__VXNHq`
};
export default ___CSS_LOADER_EXPORT___;
